import { connect } from 'react-redux';
import { actions } from '../../../../redux/modules/systemRoles/systemRoles';
import Form from './Form';

const ms2p = (state) => {
    return {
        ...state.systemRoles,
        initialValues: state.systemRoles.item,
    };
};

const md2p = { ...actions };

export default connect(ms2p, md2p)(Form);
